module.exports = __webpack_public_path__ + "static/media/A4.53e872f6.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/A4.png
// module id = 870
// module chunks = 0